<template>
  <div class="trash-modal">
    <div class="trash-modal__backdrop">
      <div class="trash-modal__card">
        <header class="trash-modal__header">
          <h2 class="trash-modal__title">Are you sure you want to delete this paper?</h2>
        </header>

        <div class="trash-modal__actions">
          <button
            type="button"
            class="trash-modal__btn trash-modal__btn--decline"
            :disabled="isSubmitting"
            @click.prevent="closeRemoveItemModalFun"
          >
            Decline
          </button>
          <button
            type="button"
            class="trash-modal__btn trash-modal__btn--confirm"
            :disabled="isSubmitting"
            @click.prevent="removeModalItemConfirmFun"
          >
            Yes, I want
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from '@/main';
import toast from '@/services/toast';

export default {
  name: 'TrashPaperPopup',
  props: {
    trashPaperID: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      selectedBucketId: null,
      isSubmitting: false
    };
  },
  created() {
    this.selectedBucketId = this.$route && this.$route.params ? this.$route.params.bucketId : null;
  },
  methods: {
    getPaperPileListAgain() {
      if (this.selectedBucketId) {
        this.$store.dispatch('getBucketDetailsByIdOfAwerackFun', { id: this.selectedBucketId });
      } else {
        this.$store.dispatch('getAllPaperPileFun');
      }
    },

    closeRemoveItemModalFun() {
      bus.$emit('trashPaperStateBus', false);
      document.body.classList.remove('body_right_scroll_remove');
    },

    async removeModalItemConfirmFun() {
      this.isSubmitting = true;

      try {
        const res = await this.$store.dispatch('removePaperInAwerackFun', {
          id: this.trashPaperID
        });

        const successMsg = (res && res.data && res.data.msg) || 'Paper deleted successfully';
        toast.success(successMsg);

        this.getPaperPileListAgain();
        this.closeRemoveItemModalFun();
      } catch (err) {
        const errorMsg =
          (err.response && err.response.data && (err.response.data.user_msg || err.response.data.msg)) ||
          (err.data && (err.data.user_msg || err.data.msg)) ||
          'Failed to delete paper';
        toast.error(errorMsg);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$font-stack: 'MyriadProRegular', 'Lato', sans-serif;
$theme-gold: #ffd400;
$btn-hover-gold: #ffe738;
$bg-backdrop: rgba(0, 0, 0, 0.92);
$text-light: #ffffff;
$btn-decline-bg: rgba(255, 18, 18, 0.5);
$btn-confirm-bg: rgba(33, 228, 0, 0.5);

.trash-modal {
  font-family: $font-stack;

  &__backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background: $bg-backdrop;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px;
  }

  &__card {
    background: #000000;
    width: 100%;
    max-width: 480px;
    border-radius: 8px;
    padding: 24px 28px;
    color: $text-light;
    box-shadow: 0 0 16px rgba(255, 213, 0, 0.5);
    border: 1px solid rgba(255, 213, 0, 0.2);

    @media (max-width: 576px) {
      padding: 20px 16px;
    }
  }

  &__header {
    margin-bottom: 24px;
  }

  &__title {
    font-size: 1.15rem;
    font-weight: 500;
    color: $text-light;
    text-align: center;
    margin: 0;
    line-height: 1.4;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
  }

  &__btn {
    min-width: 110px;
    padding: 10px 16px;
    font-size: 1rem;
    font-weight: normal;
    font-family: inherit;
    color: $text-light;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    line-height: 1;
    transition: background 0.2s ease, color 0.2s ease, opacity 0.2s ease;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:hover:not(:disabled) {
      background: $btn-hover-gold;
      color: #22292f;
    }

    &--decline {
      background: $btn-decline-bg;
    }

    &--confirm {
      background: $btn-confirm-bg;
    }

    @media (max-width: 576px) {
      min-width: 90px;
      padding: 8px 12px;
      font-size: 0.9rem;
    }
  }
}
</style>